export default {
  install(app) {
    app.config.globalProperties.$imagesRequire = function (path) {
      // This is context require, it contains references to all modules in that directory that can be required.
      // It means dynamic requires are supported but will cause all possible modules to be included in the bundle.
      // In our case, we will use it with images so we need them in bundle.
      // Learn more:
      // https://webpack.js.org/guides/dependency-management/#require-with-expression

      // Example:
      // https://github.com/webpack/webpack/tree/master/examples/require.context#examplejs
      // eslint-disable-next-line no-undef
      const context = require.context(
        '../../../../../assets/images/',
        true,
        /\.(jpe?g|png|gif|svg)$/
      )
      const imageRequire = context('./' + path)

      // For local development:
      return imageRequire
    }
  },
}
